import { appConfig } from "../../config";
import axios from "axios";
import { jsonHeaderAuth, refreshAuthLogic } from "../fetchTools";


export const getDataHelpDesk = async (requestNo) => {


    try {
        const res = await axios.get(`${appConfig.BASE_API}/request/readTanyaJawab/${requestNo}`, jsonHeaderAuth())

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const createQuestionHelpDesk = async (payload) => {


    try {
        const res = await axios.post(`${appConfig.BASE_API}/request/submitTanyaJawab`, payload, jsonHeaderAuth())

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}